var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"print-header-button",on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._v("Печать")])}
var staticRenderFns = []

export { render, staticRenderFns }